import { useEffect, useState } from "react";
import Navbar from "../../Navbar";
import moment from "moment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {
  Typography,
  Box,
  Grid,
  Card,
  IconButton,
  CardHeader,
  Avatar,
  Stack,
  Chip,
  Tooltip,
} from "@mui/material";
import CrearRepartos2 from "./crearRepartos/CrearRepartos2";
import Verrepartos4 from "./verRepartos/Verrepartos4";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

export default function RepartosGruas() {
  let fechahoy = moment(new Date()).format("DD-MM-YYYY");
  const [pedidosGruas, setPedidosGruas] = useState([]);

  const [gruaSeleccionada, setGruaSeleccionada] = useState({});

  const [mostrarPedidos, setMostrarPedidos] = useState([]);

  // ------------------------------------------------------------------

  const [openTabla, setOpenTabla] = useState(false);
  const [verReparto, setVerReparto] = useState(false);
  const [pedidosSucursales, setpedidosSucursales] = useState(true);

  const obtenerPedidosGruas = () => {
    fetch(UrlApi + "/viajes_gruas/cantidad_pedidos_asignados")
      .then((data) => data.json())
      .then((data) => setPedidosGruas(data));
  };

  const abrirTabla = (id_vehiculo) => {
    const grua = pedidosGruas.find((grua) => grua.id_vehiculo === id_vehiculo);
    setGruaSeleccionada(grua || {}); // si no se encuentra, queda objeto vacío
    setOpenTabla(true);
    setMostrarPedidos(false);
    setVerReparto(false);
  };

  useEffect(() => {
    obtenerPedidosGruas();
  }, [openTabla]);

  const openVerRepartos = () => {
    setVerReparto(true);
    setOpenTabla(false);
    setMostrarPedidos(false);
    setpedidosSucursales(false);
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Grúas",
      "Grúa",
      "lista de Pedidos Pendientes por Grúa",
      localStorage.getItem("user"),
    );
  }, []);

  return (
    <>
      <Navbar />
      {pedidosSucursales && (
        <>
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              backgroundColor="#1F618D"
              p={2}
              mt={0.9}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={10}>
                <Typography variant="h5" color="#ffffff">
                  {openTabla ? (
                    <span>Creando Nueva Rendición</span>
                  ) : (
                    <span>Pedidos de Grúa no Asignados</span>
                  )}
                </Typography>
              </Grid>
              <Grid item xs={0.5}>
                <Tooltip title="Ver Rendiciones" placement="left" arrow>
                  <IconButton
                    onClick={() => openVerRepartos()}
                    sx={{ border: "white", color: "#ffffff" }}
                  >
                    <LocalShippingIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
          {!openTabla && mostrarPedidos ? (
            <Grid
              container
              spacing={4}
              paddingTop={2}
              paddingLeft={4}
              paddingRight={4}
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              flexWrap="wrap"
            >
              {pedidosGruas.map((elemento) => {
                const sinPedidos = elemento.cantidad_pedidos === 0;

                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={elemento.id_vehiculo}
                  >
                    <Card
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        boxShadow: 3,
                        cursor: sinPedidos ? "not-allowed" : "pointer",
                        borderColor: sinPedidos ? "#ccc" : elemento.color_id,
                        opacity: sinPedidos ? 0.6 : 1,
                        backgroundColor: sinPedidos ? "#f5f5f5" : "white",
                        transition: "transform 0.2s ease",
                        "&:hover": {
                          transform: sinPedidos ? "none" : "scale(1.03)",
                        },
                      }}
                      onClick={() => {
                        if (sinPedidos) return; // No permitir acción si no tiene pedidos

                        if (parseInt(localStorage.getItem("sector")) !== 12) {
                          alert("No tiene permiso para realizar esta acción.");
                        } else {
                          abrirTabla(elemento.id_vehiculo);
                        }
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar
                          sx={{
                            bgcolor: sinPedidos ? "#9e9e9e" : "#1F618D",
                            width: 56,
                            height: 56,
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          {elemento.id_vehiculo}
                        </Avatar>

                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: "bold",
                              lineHeight: 1.2,
                              color: sinPedidos ? "#757575" : "inherit",
                            }}
                          >
                            {elemento.patente}
                          </Typography>
                        </Box>

                        <Chip
                          label={`${elemento.cantidad_pedidos}`}
                          sx={{
                            bgcolor: sinPedidos ? "#e0e0e0" : "#e0f7fa",
                            color: sinPedidos ? "#9e9e9e" : "#00796b",
                            fontWeight: "bold",
                          }}
                        />
                      </Stack>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          ) : null}

          {openTabla ? (
            <CrearRepartos2
              setOpen={setOpenTabla}
              setVerReparto={setVerReparto}
              actualizar={obtenerPedidosGruas}
              gruaSeleccionada={gruaSeleccionada}
              setMostrarPedidos={setMostrarPedidos}
            />
          ) : null}

          {Object.keys(pedidosGruas).length === 0 ? (
            <Grid
              container
              paddingTop={4}
              justifyContent={"center"}
              alignItems="flex-start"
              flexWrap="wrap"
            >
              <Card>
                <CardHeader
                  avatar={<Avatar sx={{ bgcolor: "red" }}>X</Avatar>}
                  title="No hay grúas disponibles para asignar un viaje"
                />
              </Card>
            </Grid>
          ) : null}
          <br />
        </>
      )}

      {verReparto ? (
        <Verrepartos4
          setOpen={setOpenTabla}
          setVerReparto={setVerReparto}
          actualizar={obtenerPedidosGruas}
          setpedidosSucursales={setpedidosSucursales}
          setMostrarPedidos={setMostrarPedidos}
        />
      ) : null}
    </>
  );
}
